module.exports = __webpack_public_path__ + "img/login-background.fdd167c9.png";